<router-outlet></router-outlet>
<mui-hero-right-app-bar>
  <ng-container *ngIf="authenticated$ | async">
    <ng-container
      *mmuRemoteComponent="notificationConfiguration"
      data-qa="notification-center-container"></ng-container>
  </ng-container>
</mui-hero-right-app-bar>
